$(document).ready(function() {
	var lang = $('html').attr('lang');

	/**
	 * Gestion resize + scroll
	 */
	// Resize de la fenêtre
	resize_window();
	$(window).resize(function() {
		resize_window();
	});

	// Gestion du scroll
	$(window).scroll(function() {

	});

	// Shifter
	$.shifter({
		maxWidth: '4096px'
	});

	// WOW
	new WOW().init();

	// Lazyload
	lazyload();

	// Formulaires
	if ($('.form_common').length > 0) {
		$('.form_common').each(function() {
			var form = $(this);
			form.find('input, select, textarea').each(function() {
				var field = $(this);
				field.on('focus', function() {
					field.addClass('validation');
				});
			});
		});
	}

	// Accordéon
	if ($('.accordeon_toggle').length > 0) {
		$('.accordeon_toggle').on('click', function(e) {
			e.preventDefault();

			var link = $(this);
			var content = $(link.attr('href'));

			if (!link.hasClass('active')) {
				$('.accordeon_toggle').removeClass('active');
				link.addClass('active');
				$('.accordeon_content:visible').slideUp(800);
				content.slideDown(800);
			}
		});

		if (window.location.hash != '' && $('.accordeon_toggle[href="' + window.location.hash + '"]').length > 0) {
			$('.accordeon_toggle[href="' + window.location.hash + '"]').trigger('click');
			$('html, body').animate({scrollTop: $('.accordeon_toggle[href="' + window.location.hash + '"]').offset().top - $('.header').height()}, 2000, 'easeOutExpo');
		} else {
			$('.accordeon_toggle').first().trigger('click');
		}
	}

	// Rate it
	if ($('.rateit').length > 0) {
		$('.rateit').on('click', function() {
			var rateit = $(this);
			var rateit_users_id = rateit.data('usersid');
			var rateit_produits_id = rateit.data('produitsid');
			var rateit_note = rateit.rateit('value');

			$.ajax({
				type	: "POST",
				url		: lang_path+"/produits/rateit/index.html",
				data	: 'users_id=' + rateit_users_id + '&produits_id=' + rateit_produits_id + '&note=' + rateit_note,
				error	: function(msg) {
					alert(msg);
				},
				success	: function(data) {
					rateit.rateit('readonly', true);
				}
			});
		});
	}

	if ($('.bandeau_carrousel').length > 0) {
		var carrousel_bandeau = $('.bandeau_carrousel').owlCarousel({
			loop: true,
			items: 1,
			margin: 0,
			lazyLoad: true,
			autoplay: true,
			autoplayTimeout: 5000,
			autoplayHoverPause: false,
			animateIn: 'fadeIn',
			animateOut: 'fadeOut'
		});
	}
});

function resize_window() {

}
